const BaseAPIPathRetail = "/api/intercomretail";
const BaseAPIPath = "/api/intercom";
const BaseHelpSupportAPIPath = `${BaseAPIPathRetail}/help-support`;

export const getCategoryAPIPath = (categoryUri: string) => {
  return `${BaseHelpSupportAPIPath}/categories/${categoryUri}`;
};

export const getSubcategoryAPIPath = (
  categoryUri: string,
  subcategoryUri: string
) => {
  return `${getCategoryAPIPath(categoryUri)}/subcategories/${subcategoryUri}`;
};

export const getArticleAPIPath = (
  categoryUri: string,
  subcategoryUri: string,
  articleUri: string
) => {
  return `${getSubcategoryAPIPath(
    categoryUri,
    subcategoryUri
  )}/articles/${articleUri}`;
};

export const searchAPIPath = () => `${BaseHelpSupportAPIPath}/search`;

export const userAPIPath = () => `${BaseAPIPath}/v2/user`;
